//#region src/date-picker/utils/transform-sio-date-format-to-date-picker.ts
var e = {
	d: "dd",
	m: "MM",
	Y: "yyyy"
}, t = {
	A: "a",
	h: "hh",
	H: "HH",
	i: "mm",
	s: "ss"
}, n = (t) => t.split(/([ :/])/).map((t) => t.split("").map((t) => e[t] || t).join("")).join(""), r = (e) => e.split(/([ :/])/).map((e) => e.split("").map((e) => t[e] || e).join("")).join(""), i = (e, t) => ({
	dateFormat: n(t),
	timeFormat: r(e)
});
//#endregion
export { i as transformSioDateFormatToDatePicker, n as transformSioDatePartToDatePicker, r as transformSioTimePartToDatePicker };
